import { TranslateService } from '@ngx-translate/core';

import { AuditReportStateEnum } from '../../shared/enums/audit-report-state-enum';
import { ErrorCodeClassEnum } from '../../shared/enums/error-code-class-enum';
import { NotificationServiceWrapper } from '../notification-service-wrapper/notification-service-wrapper';
import { User } from '../user-service/model/user.model';
import { UserRights } from '../user-service/user-rights.enum';

export function translateAuditReportState(auditReportState: string, translateService: TranslateService): string {
  let auditReportStateTranslation = '';
  switch (auditReportState) {
    case AuditReportStateEnum.OPEN: {
      auditReportStateTranslation = translateService.instant('RECOURSE_AUDIT_REPORT_STATE_OPEN');
      break;
    }
    case AuditReportStateEnum.CANCELLED: {
      auditReportStateTranslation = translateService.instant('RECOURSE_AUDIT_REPORT_STATE_CANCELLED');
      break;
    }
    case AuditReportStateEnum.CLOSED: {
      auditReportStateTranslation = translateService.instant('RECOURSE_AUDIT_REPORT_STATE_CLOSED');
      break;
    }
    // no default
  }
  return auditReportStateTranslation;
}

export function isViewable(user: User, suppliersAndRates: boolean): boolean {
  const rights = user.rights;
  return suppliersAndRates ? hasAfterSalesSuppliersAndRatesRight(rights) : hasAfterSalesReadRight(rights);
}

export function hasAfterSalesReadRight(rights: UserRights[]): boolean {
  return checkUserRight(rights, UserRights.AFTERSALES_READ);
}

export function hasAfterSalesSuppliersAndRatesRight(rights: UserRights[]): boolean {
  return checkUserRight(rights, UserRights.AFTERSALES_SUPPLIER_AND_RATES);
}

export function hasAfterSalesReadOrSuppliersAndRatesRight(rights: UserRights[]): boolean {
  return hasAfterSalesReadRight(rights) || hasAfterSalesSuppliersAndRatesRight(rights);
}

export function checkUserRight(rights: UserRights[], userRight: UserRights): boolean {
  return rights?.includes(userRight);
}

export function showAdditionalCostsDeleteFailed(
  notificationServiceWrapper: NotificationServiceWrapper,
  translateService: TranslateService,
  additionalCostId: any,
  auditReportId: any,
): void {
  translateService
    .get(['TITLE_FAILED', 'DELETE_ADDITIONAL_COST_FAILED'])
    .subscribe((translate: { [key: string]: any }) => {
      const title: string = translate.TITLE_FAILED;
      const content: string = translateService.instant('DELETE_ADDITIONAL_COST_FAILED', {
        0: additionalCostId,
        1: auditReportId,
      });

      notificationServiceWrapper.addErrorNotification(title, content);
    });
}

export function showAdditionalCostsDeleteSuccess(
  notificationServiceWrapper: NotificationServiceWrapper,
  translateService: TranslateService,
  additionalCostId: any,
  auditReportId: any,
): void {
  translateService
    .get(['DELETE_ADDITIONAL_COST_TITLE', 'DELETE_ADDITIONAL_COST_SUCCESSFUL'])
    .subscribe((translate: { [key: string]: any }) => {
      const title: string = translate.DELETE_ADDITIONAL_COST_TITLE;
      const content: string = translateService.instant('DELETE_ADDITIONAL_COST_SUCCESSFUL', {
        0: additionalCostId,
        1: auditReportId,
      });

      notificationServiceWrapper.addSuccessNotification(title, content);
    });
}

export function translateErrorCodeClass(errorCodeClass: string, translateService: TranslateService): string {
  let translatedErrorCodeClass = '';

  switch (errorCodeClass) {
    case ErrorCodeClassEnum.A: {
      translatedErrorCodeClass = translateService.instant('ERROR_COST_RATE_CLASS_A');
      break;
    }
    case ErrorCodeClassEnum.B: {
      translatedErrorCodeClass = translateService.instant('ERROR_COST_RATE_CLASS_B');
      break;
    }
    default: {
      break;
    }
  }
  return translatedErrorCodeClass;
}
